export default "__VITE_ASSET__5f148e23__"